import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import SignIn from './components/SignIn';
import PrivateRoute from './components/PrivateRoute';
import Dashboard from './components/Dashboard';
import SignUp from './components/SignUp';
import ResetPassword from './components/ResetPassword';
import BeamDesign from './modules/BeamDesign';
import ColumnDesign from './modules/ColumnDesign';
import PadFootingDesign from './modules/PadFootingDesign';
import ConnectionDesign from './modules/ConnectionDesign';
import LandingPage from './components/LandingPage';
import TermsOfUse from './components/TermsOfUse';
import Privacy from './components/Privacy';
import SectionLibraryPreview from './components/SectionLibraryPreview';
import SectionLibraryWrapper from './components/SectionLibraryWrapper';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import DesignModuleGrid from './components/DesignModuleGrid';
import ConsultingServices from './components/ConsultingServices';
import EngineeringTools from './components/EngineeringTools';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#2e7d32', // Forest green that complements your blue logo
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/section-library-preview" element={<SectionLibraryPreview />} />
            <Route path="/section-library" element={<PrivateRoute><SectionLibraryWrapper /></PrivateRoute>} />
            <Route path="/consulting" element={<ConsultingServices />} />
            <Route path="/engineering-tools" element={<EngineeringTools />} />
            <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
            <Route path="/beam-design" element={<PrivateRoute><BeamDesign /></PrivateRoute>} />
            <Route path="/column-design" element={<PrivateRoute><ColumnDesign /></PrivateRoute>} />
            <Route path="/pad-footing-design" element={<PrivateRoute><PadFootingDesign /></PrivateRoute>} />
            <Route path="/connection-design" element={<PrivateRoute><ConnectionDesign /></PrivateRoute>} />
            <Route path="/design" element={<DesignModuleGrid />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App; 